export default {
  SET_KANBAN_CARDS_LIST(state, data) {
    state.kanban_cards = data
  },
  SET_CRM_STEPS(state, data) {
    state.crm_steps = data
  },
  SET_LID(state, data) {
    state.lid = data
  },
  SET_PRODUCTS_LIST(state, data) {
    state.products = data
  },
}
